export class RoutePlanShipmentResult {
  shipmentIdentifier: number;
  shipmentId: number;
  mileage?: number;

  constructor(opts: RoutePlanShipmentResult) {
    this.shipmentIdentifier = opts.shipmentIdentifier;
    this.shipmentId = opts.shipmentId;

    if (opts.mileage != null) {
      this.mileage = opts.mileage;
    }
  }
}
